<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div v-if="!loading && errorCarga" class="alert alert-danger" data-cy="acreditacion-carga-error">
            <p class="mb-2">{{ errorCarga }}</p>
            <Button type="button" variant="danger" data-cy="acreditacion-reintentar" @click="reintentarCarga()">Reintentar</Button>
        </div>
        <b-row class="row" v-if="!loading">
            <b-col cols="12">
                <FormInput label="Nombre" type="text" name="nombre" id="nombre" rules="required" v-model="localAcreditacion.nombre" />
            </b-col>
            <b-col cols="12">
                <FormInput label="Medio" type="text" name="medio" id="medio" rules="" v-model="localAcreditacion.medio" />
            </b-col>
            <b-col cols="12">
                <FormInput label="Función" type="text" name="funcion" id="funcion" rules="max:20" v-model="localAcreditacion.funcion" />
            </b-col>
            <b-col cols="12">
                <DocumentoTipo
                    v-model="localAcreditacion.tipoDocumento"
                    :index="0"
                />
            </b-col>
            <b-col cols="12">
                <DocumentoValor
                    v-model="localAcreditacion.dni"
                    :type="localAcreditacion.tipoDocumento"
                    :index="0"
                />
            </b-col>
            <b-col cols="12">
                <FormInput label="Email" type="text" name="email" id="email" rules="email" v-model="localAcreditacion.email" />
            </b-col>
            <b-col cols="12">
                <FormInput label="Telefono" type="text" name="telefono" id="telefono" rules="numeric" v-model="localAcreditacion.telefono" />
            </b-col>
            <b-col cols="12">
                <FormInput label="Staff, prensa, servicios, etc" type="text" name="servicios" id="servicios" rules="" v-model="localAcreditacion.servicios" />
            </b-col>
            <b-col cols="12">
                <FormInput label="Jornada" type="text" name="jornada" id="jornada" rules="" v-model="localAcreditacion.jornada" />
            </b-col>
            <b-col cols="12" class="mb-3">
                <label for="nombre">Acceso a zonas</label>
                <ValidationProvider name="acceso_zonas" rules="" v-slot="{ errors }">
                    <QuillEditor
                        ref="editorAccesoZonas"
                        v-model="localAcreditacion.acceso_zonas"
                        data-cy="editor-acceso-zonas"
                        :print-box="printBoxPara('acceso_zonas')"
                    />
                    <span v-if="errors[0]" class="mt-1 text-xs text-white d-block bg-danger" style="padding: 5.5px;">{{ errors[0] }}</span>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" class="mb-3">
                <label for="nombre">Observaciones</label>
                <ValidationProvider name="observaciones" rules="" v-slot="{ errors }">
                    <QuillEditor
                        ref="editorObservaciones"
                        v-model="localAcreditacion.observaciones"
                        data-cy="editor-observaciones"
                        :print-box="printBoxPara('observaciones')"
                    />
                    <span v-if="errors[0]" class="mt-1 text-xs text-white d-block bg-danger" style="padding: 5.5px;">{{ errors[0] }}</span>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" v-if="activacion" class="mb-3">
                <label for="nombre">Mensaje (Texto que le llegara al correo del solicitante)</label>
                <ValidationProvider name="observaciones" rules="" v-slot="{ errors }">
                    <QuillEditor
                        ref="editorMensaje"
                        v-model="localAcreditacion.mensaje"
                        data-cy="editor-mensaje"
                    />
                    <span v-if="errors[0]" class="mt-1 text-xs text-white d-block bg-danger" style="padding: 5.5px;">{{ errors[0] }}</span>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" class="mb-3">
                <label for="nombre">Condiciones</label>
                <ValidationProvider name="condiciones" rules="" v-slot="{ errors }">
                    <QuillEditor
                        ref="editorCondiciones"
                        v-model="localAcreditacion.condiciones"
                        data-cy="editor-condiciones"
                        :print-box="printBoxPara('condiciones')"
                    />
                    <span v-if="errors[0]" class="mt-1 text-xs text-white d-block bg-danger" style="padding: 5.5px;">{{ errors[0] }}</span>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" class="mb-3">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="all-access" data-cy="all-access" v-model="allAccess"/>
                    <label for="all-access" class="custom-control-label">All access</label>
                </div>
            </b-col>
            <b-col v-if="puertas && !allAccess" cols="12" class="mb-3">
                <label>Puertas</label>
                <ValidationProvider name="puertas" id="puertas" rules="required" v-slot="{ errors }">
                    <multiselect
                        role="button"
                        v-model="localAcreditacion.puertasSelect"
                        id="puertas-select"
                        placeholder="Puertas"
                        :class="(errors[0] ? 'is-invalid' : '')"
                        :max-height="150"
                        :multiple="true"
                        label="nombre"
                        track-by="id"
                        :options="puertas"
                    />
                    <span v-if="errors[0]" class="mt-1 text-xs text-white d-block bg-danger" style="padding: 5.5px;">{{ errors[0] }}</span>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" class="mt-3 d-flex justify-content-between align-items-center">
                <Button type="submit" name="button" :disabled="!puedeGuardar || terminado">{{activacion ? 'Activar'  : 'GUARDAR'}}</Button>
            </b-col>
        </b-row>
        <LoaderComponent v-else/>
    </ValidationObserver>
</template>

<script setup>
    import { getCurrentInstance, ref } from 'vue';
    import DocumentoTipo from '@/components/common/DocumentoTipo.vue';
    import DocumentoValor from '@/components/common/DocumentoValor.vue';
    import QuillEditor from '@/modules/ui/QuillEditor.vue';
    import { useAcreditacionForm } from '@/composables/admin/events/useAcreditacionForm';

    const props = defineProps({
        evento_id: {
            type: [Number, String],
            required: true
        },
        acreditacion: {
            type: Object,
            default: () => ({})
        },
        activacion: {
            type: Boolean,
            default: false
        }
    });

    const emit = defineEmits(['terminado']);

    const instance = getCurrentInstance();

    const observer = ref(null);
    const editorAccesoZonas = ref(null);
    const editorObservaciones = ref(null);
    const editorMensaje = ref(null);
    const editorCondiciones = ref(null);

    const {
        loading,
        terminado,
        puertas,
        allAccess,
        localAcreditacion,
        errorCarga,
        puedeGuardar,
        printBoxPara,
        reintentarCarga,
        submit
    } = useAcreditacionForm({
        props,
        emit,
        store: instance.proxy.$store,
        config: instance.proxy.config,
        validar: () => observer.value.validate(),
        editores: {
            acceso_zonas: editorAccesoZonas,
            observaciones: editorObservaciones,
            mensaje: editorMensaje,
            condiciones: editorCondiciones
        }
    });
</script>
